import React, { useState } from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, BarChart, Bar } from 'recharts';
import Icon from '../../../components/AppIcon';

const RevenueCharts = ({ dateRange }) => {
  const [activeTab, setActiveTab] = useState('revenue');

  const revenueData = [
    { name: 'Jan 15', revenue: 2400, plays: 1200 },
    { name: 'Jan 16', revenue: 3200, plays: 1800 },
    { name: 'Jan 17', revenue: 2800, plays: 1500 },
    { name: 'Jan 18', revenue: 4100, plays: 2200 },
    { name: 'Jan 19', revenue: 3600, plays: 1900 },
    { name: 'Jan 20', revenue: 5200, plays: 2800 },
    { name: 'Jan 21', revenue: 4800, plays: 2500 }
  ];

  const gamePerformanceData = [
    { name: 'Space Quest', revenue: 4200, plays: 2100 },
    { name: 'Pixel Runner', revenue: 3800, plays: 1900 },
    { name: 'Mystic Realms', revenue: 2600, plays: 1300 },
    { name: 'Cyber Strike', revenue: 2100, plays: 1050 },
    { name: 'Adventure Island', revenue: 1800, plays: 900 }
  ];

  const tabs = [
    { id: 'revenue', label: 'Revenue Trends', icon: 'TrendingUp' },
    { id: 'games', label: 'Game Performance', icon: 'BarChart3' },
    { id: 'engagement', label: 'User Engagement', icon: 'Users' }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between mb-6 space-y-4 lg:space-y-0">
        <h2 className="text-xl font-semibold text-foreground">Performance Analytics</h2>
        
        <div className="flex items-center space-x-2">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`flex items-center space-x-2 px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                activeTab === tab.id
                  ? 'bg-primary text-primary-foreground'
                  : 'text-muted-foreground hover:text-foreground hover:bg-muted'
              }`}
            >
              <Icon name={tab.icon} size={16} />
              <span className="hidden sm:inline">{tab.label}</span>
            </button>
          ))}
        </div>
      </div>

      <div className="h-80">
        {activeTab === 'revenue' && (
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={revenueData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip 
                formatter={(value) => [`$${value}`, 'Revenue']}
                labelFormatter={(label) => `Date: ${label}`}
              />
              <Line 
                type="monotone" 
                dataKey="revenue" 
                stroke="#3b82f6" 
                strokeWidth={2}
                dot={{ fill: '#3b82f6' }}
              />
            </LineChart>
          </ResponsiveContainer>
        )}

        {activeTab === 'games' && (
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={gamePerformanceData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip 
                formatter={(value) => [`$${value}`, 'Revenue']}
                labelFormatter={(label) => `Game: ${label}`}
              />
              <Bar dataKey="revenue" fill="#3b82f6" />
            </BarChart>
          </ResponsiveContainer>
        )}

        {activeTab === 'engagement' && (
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={revenueData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip 
                formatter={(value) => [`${value}`, 'Plays']}
                labelFormatter={(label) => `Date: ${label}`}
              />
              <Line 
                type="monotone" 
                dataKey="plays" 
                stroke="#10b981" 
                strokeWidth={2}
                dot={{ fill: '#10b981' }}
              />
            </LineChart>
          </ResponsiveContainer>
        )}
      </div>
    </div>
  );
};

export default RevenueCharts;